package com.example.mystybag.appCore.views.pages

import androidx.compose.runtime.Composable
import com.example.mystybag.appCore.logic.pages.MenuViewModel

@Composable
fun MenuWebView(viewModel: MenuViewModel) {
    ComingSoonWebView()
}
